const fromdata = [{
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
		options: [],
	},
	{
		inputdata: "",
		title: "生产厂商",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
		options: [],
	},
	{
		inputdata: "",
		title: "平台编号",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
		options: [],
	},
	{
		inputdata: "",
		title: "第一季度指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
	},
	{
		inputdata: "",
		title: "第二季度指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
	},
	{
		inputdata: "",
		title: "第三季度指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
	},
	{
		inputdata: "",
		title: "第四季度指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
	}
];
export default fromdata;